import { FeeType, OffersGetAllQuery, OfferStatus } from '../../types';

export const getNotFounds = (
  data: OffersGetAllQuery,
  containerList: string[] | string,
): OffersGetAllQuery => {
  if (typeof containerList === 'string' || !containerList) return data;

  containerList = containerList.filter(
    (number) => !data.data.some((item: any) => item.container.number === number),
  );

  const result = [
    ...data.data,
    ...containerList.map((number) => ({
      id: '',
      price: [0],
      fee: [{ type: FeeType.PERCENTAGE, value: 0 }],
      ownerPrice: [0],
      createdAt: new Date(),
      closedAt: undefined,
      status: OfferStatus.NOT_FOUND,
      container: {
        images: [],
        number,
      },
      buyerClient: { code: '' },
      sellerClient: { code: '' },
    })),
  ] as OffersGetAllQuery['data'];

  return {
    data: result,
    totalCount: result.length,
  };
};
